"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PeaceOfMindSecured() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: badgeRef,
    isVisible: badgeVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: captionRef,
    isVisible: captionVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="221" id="peace-of-mind-secured" className="bg-background text-foreground relative w-full overflow-hidden" style={{
    minHeight: "85vh"
  }}>
      {}
      <div className="absolute inset-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701321/img/vanguard_shield_hero.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701321/img/vanguard_shield_hero.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701321/img/vanguard_shield_hero.webp-wvc-sizes" alt="Modern architectural structure representing security and stability" loading="lazy" decoding="async" className="h-full w-full object-cover" />
        {}
        <div className="absolute inset-0" style={{
        background: "linear-gradient(to top, hsl(215 45% 7% / 0.95) 0%, hsl(215 45% 7% / 0.7) 35%, hsl(215 45% 7% / 0.3) 70%, hsl(215 45% 7% / 0.1) 100%)"
      }} />
      </div>

      {}
      <div ref={badgeRef} className={`absolute top-6 right-6 sm:top-10 sm:right-10 lg:top-12 lg:right-[8%] z-10 transition-all duration-700 ease-out ${badgeVisible ? "opacity-100 scale-100" : "opacity-0 scale-75"}`}>
        <div className="flex items-center justify-center rounded-lg text-center" style={{
        width: "120px",
        height: "120px",
        backgroundColor: "hsl(155 85% 35%)",
        color: "hsl(215 45% 7%)",
        boxShadow: "var(--shadow-lg)"
      }}>
          <div className="px-4">
            <p className="font-default font-bold text-[11px] uppercase tracking-[0.15em] leading-tight">
              A+ Rated
              <br />
              <span className="font-medium">·</span>
              <br />
              Secure
              <br />
              Coverage
            </p>
          </div>
        </div>
      </div>

      {}
      <div className="relative z-10 flex min-h-[85vh] items-end">
        <div ref={contentRef} className={`w-full px-6 pb-16 sm:px-10 sm:pb-20 lg:pl-[8%] lg:pr-[8%] lg:pb-24 transition-all duration-1000 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="max-w-4xl">
            {}
            <div className="h-12 sm:h-16 lg:h-20" />

            {}
            <h1 className="font-default font-light text-white leading-[1.05] mb-8" style={{
            fontSize: "clamp(2.5rem, 7vw, 6rem)"
          }}>
              Fortifying your future with{" "}
              <em className="font-serif italic font-light" style={{
              color: "hsl(155 85% 35%)"
            }}>
                unwavering protection
              </em>
            </h1>

            {}
            <p className="font-default text-base sm:text-[18px] leading-relaxed max-w-xl mb-10" style={{
            color: "hsl(215 15% 85%)"
          }}>
              Vanguard Shield Insurance provides comprehensive coverage solutions designed for the modern enterprise. We deliver precision, reliability, and 24/7 support to ensure your assets remain secure in an unpredictable world.
            </p>

            {}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="h-12 px-8 font-default text-sm tracking-wide bg-primary text-primary-foreground hover:bg-primary/90">
                <Link to="/HomePage">Get a Free Quote</Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="h-12 px-8 font-default text-sm tracking-wide bg-transparent border text-white hover:bg-white/10 hover:text-white" style={{
              borderRadius: "0px",
              borderColor: "hsl(155 85% 35%)"
            }}>
                <Link to="/ClaimsCenterPage">
                  Claims Support
                  <ArrowRight className="ml-1" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>

      {}
      <div ref={captionRef} className={`absolute bottom-6 right-6 sm:bottom-8 sm:right-10 lg:bottom-10 lg:right-[8%] z-10 transition-opacity duration-1000 ${captionVisible ? "opacity-100" : "opacity-0"}`}>
        <p className="font-mono text-xs sm:text-sm" style={{
        color: "hsl(215 15% 65%)"
      }}>
          SEC_01: Global Risk Management Standards.
        </p>
      </div>
    </section>;
}